import * as angular from "angular";
import * as _ from "lodash";
import * as $ from "jquery";
import {IQService, IRootScopeService} from "angular";
import {MapsCommonService} from "./mapsCommon.service";
import {PolylineService} from "./polyline.service";
import {TaskModel} from "../../tasks/models/task.model";


export class ItineraryMapService {

  $$references: any = {
    itinerary: null,
    agentLocationMarker: null,
    deregisterAgentLocationMarkerCb: null,
    taskMarkers: null
  };
  infowindow: any;

  constructor(private $task, private polylineService: PolylineService, private $rootScope: IRootScopeService, private $q: IQService, private mapsCommonService: MapsCommonService,
              private $agentLocation, private mapConstant, private $filter) {
  }


  setAgentMarker(scope, map, agentId) {
    const deferred = this.$q.defer();

    this.$agentLocation(agentId).$bind(scope, 'agentLocation_' + agentId).then(
      (agentLocation) => {

        this.resetAgentMarker();

        const marker = new google.maps.Marker({
          position: agentLocation.location,
          map: map,
          icon: this.getAgentIcon(),
          zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX)
        });
        marker.set("id", agentId);
        marker.set("type", 'AgentMarker');
        marker.set("name", 'agentLocation_' + agentId);


        this.$$references.agentLocationMarker = marker;

        //Bringoz Map - Should delete
        const deregisterUpdatesCb = this.$agentLocation(agentId).$registerOnUpdateHandler(scope, (agentLocation) => {

          if (_.isEqual(agentLocation.holderId, agentId)) {
            const latLngPosition = new google.maps.LatLng(agentLocation.coordinates);
            marker.setPosition(latLngPosition);
            this.$rootScope.$emit(this.mapConstant.events.itinerary.refresh, marker);
          }

        });

        this.$$references.deregisterAgentLocationMarkerCb = deregisterUpdatesCb;

        deferred.resolve(marker);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  setTaskMarkers(map, taskIds) {

    // if ($$references.taskMarkers) {
    //     _.forEach($$references.taskMarkers, function(taskMarker) {
    //         taskMarker.setMap(null);
    //     });
    //     $$references.taskMarkers = null;
    // }

    let deferredTaskMarkers = [];

    if (_.isEmpty(taskIds)) {
      return this.$q.when(deferredTaskMarkers);
    }

    _.forEach(taskIds, (taskId, index) => {
      const deferred = this.$q.defer();

      deferredTaskMarkers.push(deferred.promise);

      this.$task(taskId).$asyncValue().then(
        (task: TaskModel) => {
          const marker = new google.maps.Marker({
            position: task.taskSpec.address.location,
            map: map,
            // label: {
            //   text: _.toString(index + 1),
            //   color: 'white',
            //   fontSize: "12px",
            //   fontWeight: "600",
            //   fontFamily: "Roboto"
            // },
            // icon: this.getItineraryIcon(task.taskSpec.purpose),
            icon: this.mapsCommonService.buildRoutedTaskIconWithStatus(task.taskSpec.purpose, task.status, (index + 1), false, task.taskType === 'BundledStopover'),
            zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX)
          });
          marker.set("type", 'TaskMarker');
          marker.set("name", 'taskMarker_' + taskId);
          marker.set("id", taskId);
          marker.set("address", task.taskSpec.address.place);
          marker.set("contact", task.taskSpec.contact);
          marker.set("notBefore", task.taskSpec.notBefore);
          marker.set("notAfter", task.taskSpec.notAfter);
          marker.set("purpose", task.taskSpec.purpose);
          marker.set("businessName", _.get(task, 'taskSpec.contact.businessName', ''));
          marker.set("serviceId", task.serviceId);


          this.registerToEvents(marker);

          deferred.resolve(marker);
        },
        deferred.reject
      );

    });

    return this.$q.all(deferredTaskMarkers);
  }

  drawMap(map, agentMarker, taskMarkers) {
    const deferred = this.$q.defer();


    const itineraryMarkers = _.concat(agentMarker, taskMarkers);

    this.$$references.taskMarkers = taskMarkers;
    this.$$references.agentLocationMarker = agentMarker;
    this.$$references.itinerary = this.polylineService.createPolyline(map, itineraryMarkers, false);


    deferred.resolve(itineraryMarkers);

    return deferred.promise;
  }

  centerMap(map, markersArrays) {

    if (!_.isEmpty(markersArrays)) {
      var bounds = new google.maps.LatLngBounds();
      markersArrays.forEach(function (marker) {
        bounds.extend(marker.position);
      });

      map.fitBounds(bounds);
    }
  }

  draw(scope, map, taskIds, agentId, isCompletedItinerary) {
    const deferred = this.$q.defer(),
      // agentMarkerPending = this.createAgentLocationMarker(scope, map, agentId),
      taskMarkersPending = this.createTaskMarkers(map, taskIds);

    this.$q.all([taskMarkersPending]).then(
      (allMarkers) => {
        const agentLocationMarker = allMarkers[0],
          taskMarkers = allMarkers[1],
          itineraryMarkers = _.concat(agentLocationMarker, taskMarkers),
          mapCenterMarkersList = [[agentLocationMarker]];

        if (!_.isEmpty(taskMarkers)) {
          mapCenterMarkersList.push(taskMarkers);
        }

        this.$$references.taskMarkers = taskMarkers;
        this.$$references.itinerary = this.polylineService.createPolyline(map, itineraryMarkers, isCompletedItinerary);

        this.$rootScope.$on(this.mapConstant.events.itinerary.refresh, (event, updatedAgentLocationMarker) => {
          this.$$references.agentLocationMarker = updatedAgentLocationMarker;
          this.polylineService.refreshPolyline(this.$$references.itinerary, _.concat(updatedAgentLocationMarker, taskMarkers));
        });

        deferred.resolve(mapCenterMarkersList)
      },
      deferred.reject
    );

    return deferred.promise;
  }

  hide(removeAgent?) {

    if (this.$$references.taskMarkers) {
      _.forEach(this.$$references.taskMarkers, (taskMarker) => {
        taskMarker.setMap(null);
      });
    }

    if (this.$$references.itinerary) {
      this.$$references.itinerary.setMap(null);
    }

    if (removeAgent && this.$$references.agentLocationMarker) {
      this.$$references.agentLocationMarker.setMap(null);
    }

  }

  show(map) {
    if (this.$$references.taskMarkers) {
      _.forEach(this.$$references.taskMarkers, (taskMarker) => {
        taskMarker.setMap(map);
      });
    }

    if (this.$$references.itinerary) {
      this.$$references.itinerary.setMap(map);
    }
  }

  selectMarker(taskMarkerId) {
    if (this.$$references.taskMarkers) {
      _.forEach(this.$$references.taskMarkers, (taskMarker) => {
        if (_.isEqual(taskMarkerId, taskMarker.id)) {
          this.infoWindowInit(taskMarker);
        }
      });
    }
  }

  // ******************************
  // Internal methods
  // ******************************


  private getAgentIcon() {
    var height = 50;
    var width = 50;
    var index = 1;

    return {
      url: 'assets/images/map/driver_markers_vr2.png',
      scaledSize: new google.maps.Size(width * 2, height),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(25, 40),
      zIndex: google.maps.Marker.MAX_ZINDEX,
      origin: new google.maps.Point(index * width, 0)
    };
  }

  private getItineraryIcon(purpose) {
    var height = 35;
    var width = 26;
    var index = purpose === 'Pickup' ? 2 : 6;

    return {
      url: 'assets/images/map/itinerary_map_markers.png',
      scaledSize: new google.maps.Size(width * 8, height),
      size: new google.maps.Size(width, height),
      origin: new google.maps.Point(index * width, 0)
    };
  }

  private resetMapMarkers() {
    const deferred = this.$q.defer();
    this.resetAgentMarker();

    if (this.$$references.taskMarkers) {
      _.forEach(this.$$references.taskMarkers, (taskMarker) => {
        taskMarker.setMap(null);
      });
      // $$references.taskMarkers = null;
    }

    if (this.$$references.itinerary) {
      this.$$references.itinerary.setMap(null);
      // $$references.itinerary = null;
    }

    this.$$references = {
      itinerary: null,
      agentLocationMarker: null,
      deregisterAgentLocationMarkerCb: null,
      taskMarkers: null
    };

    deferred.resolve();
    return deferred.promise;
  }

  private createTaskMarkers(map, taskIds) {

    let deferredTaskMarkers = [];

    if (_.isEmpty(taskIds)) {
      return this.$q.when(deferredTaskMarkers);
    }

    _.forEach(taskIds, (taskId, index) => {
      const deferred = this.$q.defer();

      deferredTaskMarkers.push(deferred.promise);

      this.$task(taskId).$asyncValue().then(
        (task: TaskModel) => {
          var marker = new google.maps.Marker({
            position: task.taskSpec.address.location,
            map: map,
            // label: {
            //   text: _.toString(index + 1),
            //   color: 'white',
            //   fontSize: "12px",
            //   fontWeight: "600",
            //   fontFamily: "Roboto"
            // },
            // icon: this.getItineraryIcon(task.taskSpec.purpose),
            icon: this.mapsCommonService.buildRoutedTaskIconWithStatus(task.taskSpec.purpose, task.status, (index + 1), false, task.taskType === 'BundledStopover'),
            zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX)
          });
          marker.set("type", 'TaskMarker');
          marker.set("name", 'taskMarker_' + taskId);
          marker.set("id", taskId);
          marker.set("address", task.taskSpec.address.place);
          marker.set("contact", task.taskSpec.contact);
          marker.set("notBefore", task.taskSpec.notBefore);
          marker.set("notAfter", task.taskSpec.notAfter);
          marker.set("purpose", task.taskSpec.purpose);
          marker.set("businessName", _.get(task, 'taskSpec.contact.businessName', ''));
          marker.set("serviceId", task.serviceId);

          this.registerToEvents(marker);

          deferred.resolve(marker);
        },
        deferred.reject
      );

    });

    return this.$q.all(deferredTaskMarkers);
  }

  private resetAgentMarker() {

    if (this.$$references.agentLocationMarker) {

      this.$$references.agentLocationMarker.setMap(null);
      this.$$references.agentLocationMarker = null;

      if (_.isFunction(this.$$references.deregisterAgentLocationMarkerCb)) {
        this.$$references.deregisterAgentLocationMarkerCb();
      }

    }

  }

  private createAgentLocationMarker(scope, map, agentId) {
    const deferred = this.$q.defer();

    this.$agentLocation(agentId).$bind(scope, 'agentLocation_' + agentId).then(
      (agentLocation) => {

        const marker = new google.maps.Marker({
          position: agentLocation.location,
          map: map,
          icon: this.getAgentIcon(),
          zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX)
        });

        marker.set("id", agentId);
        marker.set("type", 'AgentMarker');
        marker.set("name", 'agentLocation_' + agentId);


        this.$$references.agentLocationMarker = marker;

        //Bringoz Map - Should delete
        const deregisterUpdatesCb = this.$agentLocation(agentId).$registerOnUpdateHandler(scope, (agentLocation) => {

          if (_.isEqual(agentLocation.holderId, agentId)) {
            const latLngPosition = new google.maps.LatLng(agentLocation.coordinates);
            marker.setPosition(latLngPosition);
            this.$rootScope.$emit(this.mapConstant.events.itinerary.refresh, marker);
          }
        });

        this.$$references.deregisterAgentLocationMarkerCb = deregisterUpdatesCb;

        deferred.resolve(marker);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  private registerToEvents(marker) {

    marker.addListener('click', () => {
      this.infoWindowInit(marker);
      this.$rootScope.$broadcast('highlight-stopover-from-marker', marker.id);
      this.$rootScope.$applyAsync();
    });
  }

  private infoWindowInit(marker) {
    if (this.infowindow) {
      this.infowindow.close();
    }

    const purposeClass = _.isEqual(marker.purpose, 'Pickup') ? 'pickup-window' : 'dropoff-window';
    const phone = this.$filter('bringozPhone')(marker.contact.phoneNo);
    const notBefore = this.$filter('bringozTime')(marker, 'notBefore');
    const notAfter = this.$filter('bringozTime')(marker, 'notAfter');

    // InfoWindow content
    var content = '<div id="iw-task-container">' +
      '<div class="iw-title text-center ' + purposeClass + ' ">' + marker.address + '</div>' +
      '<div class="iw-content">' +
      '<div class="br-caption-2 font-weight-800 text-uppercase iw-task-purpose margin-top-5 ' + purposeClass + ' ">' + marker.purpose + '</div>' +
      '<p class="margin-top-5">' +
      '<md-icon md-svg-icon="user-outline" class="margin-right-5"></md-icon> <span class="br-caption-2">' + marker.contact.name + ' / ' + marker.businessName + '</span><br>' +
      '<md-icon md-svg-icon="phone" class="margin-right-5"></md-icon> <span class="br-caption-2">' + phone + '</span><br>' +
      '<md-icon md-svg-icon="timw-window" class="margin-right-5"></md-icon> <span class="br-caption-2">' + notBefore + ' - ' + notAfter + '</span>' +
      '</p>' +
      '</div>';

    // A new Info Window is created and set content
    this.infowindow = new google.maps.InfoWindow({
      content: content,
      maxWidth: 320
    });

    google.maps.event.addListener(this.infowindow, 'domready', () => {

      $('#iw-task-container')//the root of the content
        .closest('.gm-style-iw')
        .parent().addClass('task-iw');

      // Reference to the DIV that wraps the bottom of info window
      const iwOuter = $('.gm-style-iw');

      /* Since this div is in a position prior to .gm-div style-iw.
       * We use jQuery and create a iwBackground variable,
       * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
       */
      const iwBackground = iwOuter.prev();

      // Removes background shadow DIV
      iwBackground.children(':nth-child(2)').css({'display': 'none'});

      // Removes white background DIV
      iwBackground.children(':nth-child(4)').css({'display': 'none'});

      // Moves the infowindow 53px to the right.
      // iwOuter.parent().parent().css({left: '53px'});

      // Moves the shadow of the arrow 76px to the left margin.
      // iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

      // Moves the arrow 76px to the left margin.
      // iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

      // Changes the desired tail shadow color.
      // iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

      // Reference to the div that groups the close button elements.
      // var iwCloseBtn = iwOuter.next();
      //
      // // Apply the desired effect to the close button
      // if (_.isEqual(marker.purpose, 'P')) {
      //     iwCloseBtn.css({opacity: '1', left: '10px', top: '10px'});
      // } else {
      //     iwCloseBtn.css({opacity: '1', left: '10px', top: '10px'});
      //
      // }
      // If the content of infowindow not exceed the set maximum height, then the gradient is removed.
      // if($('.iw-content').height() < 140){
      //     $('.iw-bottom-gradient').css({display: 'none'});
      // }

      // The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
      // iwCloseBtn.mouseout(function(){
      //     $(this).css({opacity: '1'});
      // });
    });

    this.setInfoWindow(marker.map, marker);
  }

  private setInfoWindow(map, marker) {
    this.infowindow.open(map, marker);
  }

}

angular
  .module('bringoz.admin.map')
  .service('itineraryMapService', ItineraryMapService);
